import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpErrorResponse} from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';

@Injectable({providedIn: 'root'})
export class ErrorHandlerService {

  constructor(private toasterService: ToastrService,
              private router: Router) {}

  showError(error: HttpErrorResponse) {
    switch (error.status) {
      case 400:
        this.error400(error.error?.message);
        break;
      case 404:
        this.error404();
        break;
      case 500:
        this.error500(error);
        break;
      case 401:
        this.error401();
        break;
      case 403:
        this.error403();
        break;
      default:
        this.error500(error);
    }
  }

  error400(msg: string) {
    if (msg) {
      this.toasterService.error(msg);
    }
    return;
  }

  private error404() {
    this.router.navigate(['404']);
  }

  private error500(error: HttpErrorResponse) {
    this.router.navigate(['500'], { state: { errorMessage: error.error.message } });
  }

  private error401() {
  }

  private error403() {
    this.router.navigate(['403']);
  }

}
